import React from 'react';
import { Divider, Flex, IconEmptyInform } from '@banhala/ui-kit';
import { useGoodsBasic } from '../../queries/useGoodsBasic';
import { isNotNil, isNotEmpty } from 'shared/src/utils';
import { TitleContent } from './components/TitleContent';
import { StartShippingInfo } from './components/StartShippingInfo';
import { GoodsAwardRow } from './components/GoodsAwardRow';
import { useDeliveryWarningMessages } from './hooks/useDeliveryWarningMessage';
import { ArrivalExpectedDay } from './components/ArrivalExpectedDay';
import { ThirdPLArrivalExpectedDay } from './components/ThirdPLArrivalExpectedDay';
import { DeliverySection } from './components/DeliverySection';
import { HTMLText } from 'shared/src/component/HTMLText';
import { isDeliveryTypeIsThirdPL } from '../../utils/isDeliveryTypeIsThirdPL';
import { isSalesMethodIsPreOrder } from '../../utils/isSalesMethodIsPreOrder';

export const DeliveryInfo = () => {
  const { data: goodsBasic } = useGoodsBasic();

  const deliveryWarningMessages = useDeliveryWarningMessages();

  return (
    <Flex>
      <Divider size={'medium'} />
      <Flex
        padding={{
          vertical: 20,
          horizontal: 16,
          top: 20,
        }}
        gap={12}
      >
        <Flex>
          <GoodsAwardRow />
          <DeliverySection />
        </Flex>
        {(isSalesMethodIsPreOrder(goodsBasic) ||
          !isDeliveryTypeIsThirdPL(goodsBasic)) && (
          <Flex>
            <TitleContent
              title={'출발예정'}
              tooltip={
                isNotNil(goodsBasic?.delivery_type_info.icon_url) ||
                isNotNil(goodsBasic?.sales_method_info?.icon_url)
                  ? undefined
                  : '최근 3개월 배송 데이터를 분석하여 예측한 출발 예정일입니다. 판매사 및 택배사 사정 또는 배송지에 따라 실제 출발일은 다를 수 있습니다.'
              }
            >
              <StartShippingInfo />
            </TitleContent>
            <ArrivalExpectedDay />
          </Flex>
        )}
        {isDeliveryTypeIsThirdPL(goodsBasic) &&
          !isSalesMethodIsPreOrder(goodsBasic) && (
            <Flex>
              <ThirdPLArrivalExpectedDay />
            </Flex>
          )}
        {isNotEmpty(deliveryWarningMessages) && (
          <Flex.Row gap={4} alignItems={'flex-start'} margin={{ top: 4 }}>
            <Flex padding={{ top: 2 }}>
              <IconEmptyInform size={12} />
            </Flex>
            <Flex gap={4} flex={1}>
              {deliveryWarningMessages.map((message, index) => (
                <HTMLText
                  key={index}
                  type={'body3'}
                  color={'content_tertiary'}
                  wordBreakStrategy="keepAll"
                >
                  {message}
                </HTMLText>
              ))}
            </Flex>
          </Flex.Row>
        )}
      </Flex>
      <Divider size={'medium'} />
    </Flex>
  );
};
